var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileTarget1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.75C14.7574 5.75 13.75 6.75736 13.75 8C13.75 9.24264 14.7574 10.25 16 10.25C17.2426 10.25 18.25 9.24264 18.25 8C18.25 6.75736 17.2426 5.75 16 5.75ZM16 9C15.4477 9 15 8.55228 15 8C15 7.44772 15.4477 7 16 7C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8ZM12.25 8C12.25 10.0711 13.9289 11.75 16 11.75C18.0711 11.75 19.75 10.0711 19.75 8C19.75 5.92893 18.0711 4.25 16 4.25C13.9289 4.25 12.25 5.92893 12.25 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9676 2.24922C12.6809 2.09041 12.351 2 12 2H4C2.89543 2 2 2.89543 2 4V6.25H9.73829C10.2219 4.51587 11.4066 3.07406 12.9676 2.24922ZM7 3.25H9C9.41421 3.25 9.75 3.58579 9.75 4C9.75 4.41421 9.41421 4.75 9 4.75H7C6.58579 4.75 6.25 4.41421 6.25 4C6.25 3.58579 6.58579 3.25 7 3.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50472 7.75H2V17.25H14V14.1865C11.3887 13.3429 9.5 10.892 9.5 8C9.5 7.91629 9.50158 7.83294 9.50472 7.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20V18.75H14V20C14 21.1046 13.1046 22 12 22H4C2.89543 22 2 21.1046 2 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTarget1);
export default __webpack_public_path__ + "static/media/mobile-target-1.a057c872134cf390c9421278e560a77d.svg";
export { ForwardRef as ReactComponent };